(function() {
    'use strict';
    angular
        .module('functional7App')
        .factory('Ejercicio', Ejercicio);

    Ejercicio.$inject = ['$resource'];

    function Ejercicio ($resource) {
        var resourceUrl =  'api/ejercicios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
